import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-omni",
  "use": "logo-omni-usage",
  "viewBox": "0 0 75.18 76.337",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75.18 76.337\" id=\"logo-omni\"><g data-name=\"Group 112\"><path data-name=\"Path 50\" d=\"M34.402 42.546a.972.972 0 0 1-1.232-1.191L44.236 4.042c.2-.707 10.26 2.116 17.157 8.783s10.625 17.113 9.924 17.337z\" fill=\"#a21671\" /><g data-name=\"icon - beacon\"><g data-name=\"↳color\" opacity=\".7\"><circle data-name=\"Ellipse 290\" cx=\"32.049\" cy=\"32.049\" r=\"32.049\" fill=\"#ed792f\" transform=\"translate(0 12.24)\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol